import { render } from "./drainage.vue?vue&type=template&id=6e203e63&scoped=true"
import script from "./drainage.vue?vue&type=script&lang=js"
export * from "./drainage.vue?vue&type=script&lang=js"

import "./drainage.vue?vue&type=style&index=0&id=6e203e63&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e203e63"]])

export default __exports__